import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=0b4375d8"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=0b4375d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports